import * as React from 'react';
import { DefaultLayout } from '../../../components/DefaultLayout';
import { Seo } from "../../../components/Seo";

import { YandexMetrika } from '../../../components/YandexMetrika';
import { MailRu } from '../../../components/MailRu';
import { TikTok } from '../../../components/TikTok';
import { VKPixel } from '../../../components/VKPixel';
import { AdvCake } from '../../../components/AdvCake';

import { GetCourseWidget } from "../../../components/GetCourseWidget";
import { FooterFull } from "../../../components/FooterFull";

import {
  Screen1,
  Reasons,
  Help,
  Wait,
  VideoReviewsWithCards,
  TextReviews,
  Speakers,
  Reg,
  Advance
} from "../../../components/LandingTemplates/kak_vyuchit_anglijskij_new";

const TITLE = 'Как выучить английский новичку в кратчайшие сроки без зубрежки: для путешествий, работы и общего развития';
const DESCRIPTION = 'Как выучить английский - бесплатный мастер-класс';
const KEYWORDS = 'Грамматика английского языка видеоуроки бесплатно статьи материалы Advance образовательный центр вебинары английский обучение развитие памяти технологии курсы отзывы запоминание';
export const Head = () => (
  <Seo title={TITLE} description={DESCRIPTION} keywords={KEYWORDS}>
    <title>{TITLE}</title>
  </Seo>
);
const Page = (
  {
    widget = <GetCourseWidget hash={'c9211548b4191b812915dbc7342c8b4ac9954f01'} id={'40003'}/>
  }) => (
  <DefaultLayout>
    <YandexMetrika />
    <MailRu />
    <TikTok />
    <VKPixel />
    <AdvCake />

    <main>
      <Screen1 id={'kva'}/>
      <Reasons/>
      <Help/>
      <Wait/>
      <VideoReviewsWithCards/>
      <TextReviews/>
      <Speakers/>
      <Reg id={'kva'} widget={widget}/>
      <Advance widget={widget}/>
    </main>

    <FooterFull/>

  </DefaultLayout>
);
export default Page;
